export default __webpack_public_path__ + "static/media/novios.969179da.png";